import { Topbar } from '.';
import * as classNames from 'classnames';
import { RemindersAlert, RemindersCenter } from 'components/reminder';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import { Sidebar } from './Sidebar';

// Styles
const s = require('./Layout.css');

// Component
@inject('store')
@observer
export class Layout extends React.Component<IAppOnlyStore, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <div className={s.layout}>
                <Topbar />

                <div
                    className={classNames(s.page, {
                        [s.paddedBottom]: this.props.store.utilities
                            .showOfflineArea,
                    })}
                >
                    {this.props.children}
                </div>

                <Sidebar />

                <RemindersAlert />
                <RemindersCenter />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Layout.tsx